const setInsightsTranslationsKeys = allAvailableInsights => {
    return allAvailableInsights.map(insight => {
        const key = insight.key;
        switch (key) {
            case "highlights": {
                return {...insight, name: "BADGES.HIGHLIGHTS.HIGHLIGHTS"};
            }
            case "brands": {
                return {...insight, name: "BADGES.HIGHLIGHTS.BRANDS"};
            }
            case "namedLocations": {
                return {...insight, name: "BADGES.HIGHLIGHTS.LOCATIONS"};
            }
            case "namedPeople": {
                return {...insight, name: "BADGES.HIGHLIGHTS.PEOPLE"};
            }

            default:
                return insight;
        }
    });
};

export const getFeaturesRecursively = (insights, includeDisabled) => {
    if (insights && insights.length) {
        let allAvailableInsights = [];

        insights.forEach(insight => {
            if (insight.key && (!insight.disabled || includeDisabled)) {
                allAvailableInsights.push(insight);
            } else if (insight.suboptions) {
                insight.suboptions.forEach(suboption => {
                    if (suboption.key && (!suboption.disabled || includeDisabled)) allAvailableInsights.push(suboption);
                });
            }
        });

        if (allAvailableInsights.length) {
            allAvailableInsights = setInsightsTranslationsKeys(allAvailableInsights);
        }
        return allAvailableInsights;
    } else return [];
};

export const getDefaultInsightByPreference = allAvailableInsights => {
    const selectedDefault =
        allAvailableInsights.find(insight => insight.key === "highlights") ||
        allAvailableInsights.find(insight => !insight.disabled) ||
        [];

    return selectedDefault;
};
